import firebaseInstance from "../../../util/firebase";
import Helpers from "../../../util/helper";

const CTRLSTEP = 3
export default {
  getProjectDetails(state, item) {
    return new Promise(async (resolve, reject) => {
      firebaseInstance
        .database()
        .ref("projects/" + item.projectid)
        .on("value", snap2 => {
          var projectPartial = snap2.val();
          console.log("reloaded project partial", projectPartial);
          state.commit("LOAD_PROJECT_PART_DETAILS", projectPartial);
          resolve(projectPartial)
        })
    });
  },
  getProjectDetailsOnce(state, item) {
    return new Promise(async (resolve, reject) => {
      firebaseInstance
        .database()
        .ref("projects/" + item.projectid)
        .once("value", snap2 => {
          var projectPartial = snap2.val();
          resolve(projectPartial)
        })
        .catch(e => {
          console.log(e)
          resolve(null)
        })
    });
  },

  getProjectFullDetails(state, item) {
    return new Promise(async (resolve, reject) => {
      firebaseInstance
        .database()
        .ref("projectsFull/" + item.projectid)
        .on("value", snap => {
          var projectFull = snap.val();
          console.log("reloaded project full", projectFull);
          state.commit("LOAD_PROJECT_FULL_DETAILS", projectFull);
          resolve(true)
          // save project edited time when refreshing the project
          firebaseInstance
            .database()
            .ref("projects/" + item.projectid)
            .update({edited: new Date().getTime()})
        })
    });
  },
  getProjectFullDetailsOnce(state, item) {
    return new Promise(async (resolve, reject) => {
      firebaseInstance
        .database()
        .ref("projectsFull/" + item.projectid)
        .once("value", snap => {
          var projectFull = snap.val();
          resolve(projectFull)
        })
        .catch(e => {
          console.log(e)
          resolve(null)
        })
    });
  },

  clearProjectData(state, item) {
    state.commit("UPDATE_UNDO_COUNT", 0);
    state.commit('UPDATE_PROJECT_BACKUP', [])
    state.commit("LOAD_PROJECT_PART_DETAILS", {});
    state.commit("LOAD_PROJECT_FULL_DETAILS", {});
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid)
      .off("value")
    firebaseInstance
      .database()
      .ref("projects/" + item.projectid)
      .off("value")
  },
  redoAction(state, item) {
    const undoCount = state.getters.undoCount - 1
    if (undoCount < 0) {
      return;
    }
    const backUpCount = state.getters.projectBackup.length,
      backUpPosition = backUpCount - undoCount - 1
    if (backUpPosition < 0) {
      return;
    }
    firebaseInstance
      .database()
      .ref('projectsFull/' + item.projectid)
      .set(state.getters.projectBackup[backUpPosition], () => {
        state.commit("UPDATE_UNDO_COUNT", undoCount);
      })
      .catch(console.error)
  },
  undoAction(state, item) {
    const undoCount = state.getters.undoCount + 1,
      backUpCount = state.getters.projectBackup.length,
      backUpPosition = backUpCount - undoCount - 1
    if (backUpPosition < 0) {
      return;
    }
    firebaseInstance
      .database()
      .ref('projectsFull/' + item.projectid)
      .set(state.getters.projectBackup[backUpPosition], () => {
        console.log('undo action done')
        state.commit("UPDATE_UNDO_COUNT", undoCount);
      })
      .catch(console.error)
  },
  initBackUpCache(state) {
    const projectBackup = []
    projectBackup.push(state.getters.currentProjectFull)
    state.commit('UPDATE_PROJECT_BACKUP', projectBackup)
  },
  updateBackupCache(state, item) {
    const projectBackup = [],
      undoCount = state.getters.undoCount
    for (const backup of state.getters.projectBackup) {
      projectBackup.push(backup)
    }
    for (let i = 0; i < undoCount; i++) {
      projectBackup.pop()
    }
    projectBackup.push(state.getters.currentProjectFull)
    state.commit('UPDATE_PROJECT_BACKUP', projectBackup)
    state.commit("UPDATE_UNDO_COUNT", 0);
  },
  updateProjectFull(state, item) {
    return new Promise((resolve, reject) => {
      const fbRef = firebaseInstance.database().ref("projectsFull/" + item.projectid + item.child)
      if (item.update) {
        fbRef.update(item.value, () => {
          state.dispatch('updateBackupCache', { projectid: item.projectid});
          resolve();
        })
        .catch(e => reject(e));
      } else {
        fbRef.set(item.value, () => {
          state.dispatch('updateBackupCache', { projectid: item.projectid});
          resolve();
        })
        .catch(e => reject(e));
      }
    });
  },
  removeAttachmentfile(state, item) {
    return new Promise((resolve, reject) => {
      state.dispatch('updateProjectFull', {
        projectid: item.projectid,
        child:  "/modules/" + item.module + "/components/" + item.component + "/moduleColumns/metaElements/1",
        value: ''
      })
      .then(() => resolve(true))
      .catch(e => reject(e))
    });
  },
  uploadAttachmentfile(state, item) {
    return new Promise((resolve, reject) => {
      var random = Math.floor(Math.random() * 10000000000);
      var nameOfFile = item.file.name + random;
      firebaseInstance
        .storage()
        .ref("projects/" + item.projectid + "/images/" + nameOfFile)
        .put(item.file)
        .then(snapshot => {
          firebaseInstance
            .storage()
            .ref()
            .child("projects/" + item.projectid + "/images/" + nameOfFile)
            .getDownloadURL()
            .then(url => {
              var type = "file";
              if (
                item.file.type == "image/png" ||
                item.file.type == "image/jpg" ||
                item.file.type == "image/jpeg"
              ) {
                type = "image";
              }
              state.dispatch('updateProjectFull', {
                projectid: item.projectid,
                child:  "/modules/" + item.module + "/components/" + item.component + "/moduleColumns/metaElements/1",
                value: { url, type }
              }).then(() => {
                resolve(true)
              });
            })
            .catch(error => console.error);
        });
    });
  },
  updateAttachment(state, item) {
    state.dispatch('updateProjectFull', {
      projectid: item.projectid,
      child:  "/modules/" + item.moduleKey + "/components/" + item.comKey + "/moduleColumns/metaElements/1",
      value: { url: item.url, type: 'image' }
    })
  },
  saveNewTemplate(state, item) {
    var _d = new Date();
    _d = _d.getTime();
    var newTemplate = {
      project: item.projectDetails,
      projectfull: item.projectDetailsFull,
      name: item.name,
      created: _d
    };
    firebaseInstance
      .database()
      .ref("companies/" + item.company + "/templates")
      .push(newTemplate, () => {
      })
      .catch(error => {
        console.log("Error saveNewTemplate", error);
      });
  },
  revertToVersion(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid)
      .update(item.projectFull, () => {
        firebaseInstance
          .database()
          .ref("projects/" + item.projectid)
          .update(item.project, () => {
            firebaseInstance
              .database()
              .ref("projectsFull/" + item.projectid + "/versions")
              .update(item.versions, () => {
                console.log("project version reverted3");
              })
              .catch(console.error);
          })
          .catch(console.error);
      })
      .catch(console.error);
  },
  saveNewVersion(state, item) {
    console.log("saveNewTemplate", item);
    var _d = new Date();
    _d = _d.getTime();
    var newVersion = {
      project: item.projectDetails,
      projectfull: item.projectDetailsFull,
      created: _d
    };
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/versions")
      .push(newVersion, () => {})
      .catch(console.error);
  },
  showGlobalPopup(state, item) {
    if (item.show == true) {
      state.commit("SHOW_POPUP", item.projectID);
    } else {
      state.commit("HIDE_POPUP", item.projectID);
    }
  },
  showDeleteProjectPopup(state, item) {
    state.commit("SHOW_POPUP", false);
    state.commit("SHOW_DELETE_PROJECT_POPUP", item.projectID);
  },
  startShareProject(state, item) {
    state.commit("POPUP_PROJECT", item.projectid);
  },
  toggleCalculator(state, item) {
    state.commit("TOGGLE_CALCULATOR", {});
  },
  toggleComments(state, item) {
    state.commit("TOGGLE_COMMENTS", {});
  },
  togglePrices(state, item) {
    state.commit("TOGGLE_PRICES", {});
  },
  toggleHours(state, item) {
    state.commit("TOGGLE_HOURS", {});
  },
  unhideAllHourlyPercentColumns(state, item) {
    console.log("unhideAllHourlyPercentColumns", item);
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/moduleColumns")
      .once("value", snap => {
        var moduleColumns = snap.val();
        if (item.category == "hourlyElements" || item.category == "both") {
          for (var column in moduleColumns.hourlyElements) {
            delete moduleColumns.hourlyElements[column].hidden;
          }
        }
        if (item.category == "percentTasks" || item.category == "both") {
          for (var column in moduleColumns.percentTasks) {
            delete moduleColumns.percentTasks[column].hidden;
          }
        }
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child: "/moduleColumns",
          value: moduleColumns
        });
      })
      .catch(console.error);
  },
  toggleMetaColumns(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/moduleColumns")
      .once("value", snap => {
        var moduleColumns = snap.val();
        if (moduleColumns.metaElements[0].hidden) {
          for (var column in moduleColumns.metaElements) {
            delete moduleColumns.metaElements[column].hidden;
          }
        } else {
          for (var column in moduleColumns.metaElements) {
            moduleColumns.metaElements[column].hidden = true;
          }
        }
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/moduleColumns",
          value: moduleColumns
        });
      })
      .catch(console.error);
  },
  hideColumn(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/moduleColumns")
      .once("value", snap => {
        var moduleColumns = snap.val();
        if (moduleColumns[item.section][item.index].hidden) {
          delete moduleColumns[item.section][item.index].hidden;
        } else {
          moduleColumns[item.section][item.index].hidden = true;
        }
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/moduleColumns",
          value: moduleColumns
        });
      })
      .catch(console.error);
  },
  unhideColumns(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/moduleColumns")
      .once("value", snap => {
        var moduleColumns = snap.val();
        console.log("moduleColumns1", moduleColumns[item.section]);
        for (var component in item.components) {
          if (moduleColumns[item.section][item.components[component]].hidden) {
            delete moduleColumns[item.section][item.components[component]]
              .hidden;
          }
        }
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/moduleColumns",
          value: moduleColumns
        });
      })
      .catch(console.error);
  },
  disableColumn(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/moduleColumns")
      .once("value", snap => {
        var moduleColumns = snap.val();
        if (moduleColumns[item.section][item.index].disabled) {
          delete moduleColumns[item.section][item.index].disabled;
        } else {
          moduleColumns[item.section][item.index].disabled = true;
        }
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/moduleColumns",
          value: moduleColumns
        });
      })
      .catch(console.error);
  },
  indentComponent(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules/" + item.moduleindex)
      .once("value", snap => {
        var module = snap.val();
        var maxIndent = 3;
        if (module.components[item.componentid].indented) {
          if (module.components[item.componentid].indented < maxIndent) {
            module.components[item.componentid].indented =
              module.components[item.componentid].indented + 1;
          }
        } else {
          module.components[item.componentid].indented = 1;
        }
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/modules/" + item.moduleindex,
          value: module
        });
      })
      .catch(console.error);
  },
  outdentComponent(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules/" + item.moduleindex)
      .once("value", snap => {
        var module = snap.val();
        console.log("outdent...", module.components[item.componentid].indented);
        if (module.components[item.componentid]) {
          if (module.components[item.componentid].indented == 1) {
            delete module.components[item.componentid].indented;
          } else if (module.components[item.componentid].indented) {
            module.components[item.componentid].indented =
              module.components[item.componentid].indented - 1;
          }
          state.dispatch('updateProjectFull', {
            projectid: item.projectid,
            child:  "/modules/" + item.moduleindex,
            value: module
          });
        } else {
          console.log("no", module.components[item.componentid]);
        }
      })
      .catch(error => {
        console.log("Error getting module 1", error);
      });
  },
  disableComponent(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules/" + item.moduleindex)
      .once("value", snap => {
        var module = snap.val();
        if (module.components[item.componentid].disabled) {
          delete module.components[item.componentid].disabled;
        } else {
          module.components[item.componentid].disabled = true;
        }
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/modules/" + item.moduleindex,
          value: module
        });
      })
      .catch(error => {
        console.log("Error getting module 1", error);
      });
  },
  hideComponent(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules/" + item.moduleindex)
      .once("value", snap => {
        var module = snap.val();
        module.components[item.componentid].hidden = true;
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/modules/" + item.moduleindex,
          value: module
        });
      })
      .catch(error => {
        console.log("Error getting module 1", error);
      });
  },
  hideModule(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules/" + item.index)
      .once("value", snap => {
        var module = snap.val();
        module.hidden = true;
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/modules/" + item.index,
          value: module
        });
      })
      .catch(error => {
        console.log("Error getting module 1", error);
      });
  },
  unhideModule(state, item) {
    console.log("unhideModule", item);
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules")
      .once("value", snap => {
        var modules = snap.val();
        for (var component in item.modulesToUnhide) {
          modules[item.modulesToUnhide[component]].hidden == true
            ? delete modules[item.modulesToUnhide[component]].hidden
            : null;
        }
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/modules",
          value: modules
        });
      })
      .catch(error => {
        console.log("Error getting module 1", error);
      });
  },
  unhideComponents(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules/" + item.moduleindex)
      .once("value", snap => {
        var module = snap.val();
        for (var component in item.componentsToUnhide) {
          module.components[item.componentsToUnhide[component]].hidden
            ? delete module.components[item.componentsToUnhide[component]]
                .hidden
            : null;
        }
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/modules/" + item.moduleindex,
          value: module
        });
      })
      .catch(error => {
        console.log("Error getting module 1", error);
      });
  },
  addPercentColumn(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules")
      .once("value", snap => {
        firebaseInstance
          .database()
          .ref("projectsFull/" + item.projectid + "/moduleColumns")
          .once("value", snap2 => {
            var modules = snap.val();
            var moduleColumns = snap2.val();
            for (var module in modules) {
              for (var component in modules[module].components) {
                if (
                  !modules[module].components[component].moduleColumns
                    .percentTasks
                ) {
                  modules[module].components[
                    component
                  ].moduleColumns.percentTasks = [];
                }
                modules[module].components[
                  component
                ].moduleColumns.percentTasks.push({ lo: 0, mid: 0, hi: 0 });
              }
            }
            if (!moduleColumns.percentTasks) {
              moduleColumns.percentTasks = [];
            }
            moduleColumns.percentTasks.push({
              name: "New Resource",
              type: "percentElement"
            });
            console.log("new modules", modules, moduleColumns);
            var data = {
              moduleColumns,
              modules
            };
            state.dispatch('updateProjectFull', {
              projectid: item.projectid,
              child:  "",
              value: data,
              update: true
            });
          })
          .catch(error => {
            console.log("Error getting modules 2", error);
          });
      })
      .catch(error => {
        console.log("Error getting modules 1", error);
      });
  },
  addHourlyColumn(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules")
      .once("value", snap => {
        firebaseInstance
          .database()
          .ref("projectsFull/" + item.projectid + "/moduleColumns")
          .once("value", snap2 => {
            var modules = snap.val();
            var moduleColumns = snap2.val();
            var phases = item.phases;
            for (var phase in phases) {
              if (phases[phase].list) {
                for (var task in phases[phase].list) {
                  // phases[phase].list[task][0] = phases[phase].list[task][0] + 1
                }
              }
            }

            for (var module in modules) {
              for (var component in modules[module].components) {
                if (
                  !modules[module].components[component].moduleColumns
                    .hourlyElements
                ) {
                  modules[module].components[
                    component
                  ].moduleColumns.hourlyElements = [];
                }
                modules[module].components[
                  component
                ].moduleColumns.hourlyElements.push({ lo: 0, mid: 0, hi: 0 });
              }
            }
            if (!moduleColumns.hourlyElements) {
              moduleColumns.hourlyElements = [];
            }
            moduleColumns.hourlyElements.push({
              name: "New Resource",
              type: "hourlyElement"
            });
            var data = {
              moduleColumns,
              modules,
              phases
            };
            state.dispatch('updateProjectFull', {
              projectid: item.projectid,
              child:  "",
              value: data,
              update: true
            });
          })
      })
  },
  moveColumn(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid)
      .once("value", snap => {
        const modules = snap.val().modules;
        const moduleColumns = snap.val().moduleColumns;
        Helpers.dragArray(moduleColumns[item.section], item.from, item.to)
        for (const module in modules) {
          for (const component in modules[module].components) {
            Helpers.dragArray(modules[module].components[component].moduleColumns[item.section], item.from, item.to)
          }
        }
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "",
          value: { modules, moduleColumns},
          update: true
        });
      })
      .catch(error => {
        console.log("Error getting overrides", error);
      });
  },
  moveComponentRow(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules")
      .once("value", snap => {
        var modules = snap.val();
        var moveThisRow = modules[item.a].components[item.b];
        moveThisRow = modules[item.a].components.splice(item.b, 1);
        if (moveThisRow && moveThisRow[0] && moveThisRow[0].indented) {
          delete moveThisRow[0].indented;
        }
        if (item.a == item.c) {
          modules[item.c].components.splice(item.d, 0, moveThisRow[0]);
        } else {
          if (modules[item.c].components) {
            modules[item.c].components.splice(item.d, 0, moveThisRow[0]);
          } else {
            modules[item.c].components = [];
            modules[item.c].components.push(moveThisRow[0]);
          }
        }
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/modules",
          value: modules
        });
      })
      .catch(error => {
        console.log("Error getting overrides", error);
      });
  },
  swapModules(state, item) {
    var move = function(arr, old_index, new_index) {
      while (old_index < 0) {
        old_index += arr.length;
      }
      while (new_index < 0) {
        new_index += arr.length;
      }
      if (new_index >= arr.length) {
        var k = new_index - arr.length;
        while (k-- + 1) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr;
    };
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules")
      .once("value", snap => {
        var modules = snap.val();
        modules = move(modules, item.a, item.b);
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/modules",
          value: modules
        });
      })
      .catch(console.error);
  },
  deleteModule(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules")
      .once("value", snap => {
        var modules = snap.val();
        modules.splice(item.index, 1);
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/modules",
          value: modules
        });
      })
      .catch(console.error)
  },
  changeModuleName(state, item) {
    state.dispatch('updateProjectFull', {
      projectid: item.projectid,
      child:  "/modules/" + item.moduleid + "/name",
      value: item.name
    });
  },
  removeTaskFromPhase(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/phases/" + item.phase + "/list")
      .once("value", snap => {
        var tasks = snap.val() || [];
        tasks.splice(item.task, 1);
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/phases/" + item.phase + "/list",
          value: tasks
        });
      })
      .catch(console.error)
  },
  removeTaskFromPhase2(state, item) {
    firebaseInstance
      .database()
      .ref(
        "projectsFull/" + item.projectid + "/phases/" + item.phase + "/list2"
      )
      .once("value", snap => {
        var tasks = snap.val() || [];
        tasks.splice(item.task, 1);
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/phases/" + item.phase + "/list2",
          value: tasks
        });
      })
      .catch(console.error);
  },
  removeTaskFromPhase3(state, item) {
    firebaseInstance
      .database()
      .ref(
        "projectsFull/" + item.projectid + "/phases/" + item.phase + "/list3"
      )
      .once("value", snap => {
        var tasks = snap.val() || [];
        tasks.splice(item.task, 1);
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/phases/" + item.phase + "/list3",
          value: tasks
        });
      })
      .catch(console.error);
  },
  addTaskToPhase(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/phases/" + item.phase + "/list")
      .once("value", snap => {
        var tasks = snap.val() || [];
        tasks.push([item.task, 0]);
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/phases/" + item.phase + "/list",
          value: tasks
        });
      })
      .catch(console.error);
  },
  addTaskToPhase2(state, item) {
    firebaseInstance
      .database()
      .ref(
        "projectsFull/" + item.projectid + "/phases/" + item.phase + "/list2"
      )
      .once("value", snap => {
        var tasks = snap.val() || [];
        tasks.push([item.task, 0]);
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/phases/" + item.phase + "/list2",
          value: tasks
        });
      })
      .catch(console.error);
  },
  addTaskToPhase3(state, item) {
    firebaseInstance
      .database()
      .ref(
        "projectsFull/" + item.projectid + "/phases/" + item.phase + "/list3"
      )
      .once("value", snap => {
        var tasks = snap.val() || [];
        tasks.push([item.task, 0]);
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/phases/" + item.phase + "/list3",
          value: tasks
        });
      })
      .catch(console.error);
  },
  editPhaseName(state, item) {
    state.dispatch('updateProjectFull', {
      projectid: item.projectid,
      child:  "/phases/" + item.phase + "/name",
      value: item.text
    });
  },
  deletePhase(state, item) {
    var phases = item.phases;
    phases.splice(item.phase, 1);
    state.dispatch('updateProjectFull', {
      projectid: item.projectid,
      child:  "/phases/",
      value: phases
    });
  },
  savePhases(state, item) {
    state.dispatch('updateProjectFull', {
      projectid: item.projectid,
      child:  "/phases/",
      value: item.phases
    });
  },
  addNewPhase(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/phases/")
      .once("value", snap => {
        var phases = snap.val() || [];
        phases.push({
          name: "Phase",
          list: [], // hourly
          list2: [], // %
          list3: [] // fixed
        });
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/phases/",
          value: item.phases
        });
      })
      .catch(console.error);
  },
  changeTaskDetails(state, item) {
    console.log("changeTaskDetails", item);
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid)
      .once("value", snap => {
        var moduleColumns = snap.val().moduleColumns;
        var modules = snap.val().modules;

        if (item.taskTypeStart == item.taskTypeNew) {
          console.log("aa");
          moduleColumns[item.taskTypeStart][item.taskindex].useTaskRate =
            item.useTaskRate;
          moduleColumns[item.taskTypeStart][
            item.taskindex
          ].taskPercentOverride = item.taskPercentOverride;
          moduleColumns[item.taskTypeStart][item.taskindex].useTaskCost =
            item.useTaskCost;
          moduleColumns[item.taskTypeStart][item.taskindex].hourlyRateOverride =
            item.hourlyRateOverride;
          moduleColumns[item.taskTypeStart][item.taskindex].hourlyCostOverride =
            item.hourlyCostOverride;
          moduleColumns[item.taskTypeStart][item.taskindex].name = item.name;
        } else {
          console.log("bb");
          moduleColumns[item.taskTypeStart][item.taskindex].useTaskRate =
            item.useTaskRate;
          moduleColumns[item.taskTypeStart][
            item.taskindex
          ].taskPercentOverride = item.taskPercentOverride;
          moduleColumns[item.taskTypeStart][item.taskindex].useTaskCost =
            item.useTaskCost;
          moduleColumns[item.taskTypeStart][item.taskindex].hourlyRateOverride =
            item.hourlyRateOverride;
          moduleColumns[item.taskTypeStart][item.taskindex].hourlyCostOverride =
            item.hourlyCostOverride;
          moduleColumns[item.taskTypeStart][item.taskindex].name = item.name;
          // check that it's not the last task (same for delete...)

          // remove from starting index in original section
          var _col = moduleColumns[item.taskTypeStart].splice(
            item.taskindex,
            1
          );
          // add to new (at end)
          if (!moduleColumns[item.taskTypeNew]) {
            moduleColumns[item.taskTypeNew] = [];
          }
          moduleColumns[item.taskTypeNew].push(_col[0]);

          for (var module in modules) {
            for (var component in modules[module].components) {
              if (
                !modules[module].components[component].moduleColumns[
                  item.taskTypeNew
                ]
              ) {
                modules[module].components[component].moduleColumns[
                  item.taskTypeNew
                ] = [];
              }
              var _valueCol = modules[module].components[
                component
              ].moduleColumns[item.taskTypeStart].splice(item.taskindex, 1);
              modules[module].components[component].moduleColumns[
                item.taskTypeNew
              ].push(_valueCol[0]);
            }
          }
        }
        var fullProject = snap.val();
        fullProject.moduleColumns = moduleColumns;
        fullProject.modules = modules;
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "",
          value: fullProject,
          update: true
        });
      })
      .catch(error => {
        console.log("Error getting moduleColumns", error);
      });
  },
  async changeGridValue(state, item) {
    return new Promise((resolve, reject) => {
      if (item.component == "title") {
        return state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child: "/modules/" + item.key3 + "/components/" + item.key2 + "/name",
          value: item.value
        });
      } else if (item.key3 == "title") {
        return state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child: "/moduleColumns/" + item.component + "/" + item.key + "/name",
          value: item.value
        });
      } else if (item.component == "metaElements" && item.key == 0) {
        return state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child: "/modules/" + item.key3 + "/components/" + item.key2 + "/moduleColumns/" + item.component + "/" + item.key,
          value: item.value
        });
      } else {
        return state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child: "/modules/" + item.key3 + "/components/" + item.key2 + "/moduleColumns/" +
            item.component + "/" + item.key + "/" + item.pricingLevel,
          value: item.value
        });
      }
    });
  },
  async pasteGridValues(state, item) {
    return new Promise(async (resolve, reject) => {
      let components = JSON.parse(JSON.stringify(state.getters.currentProjectModules[item.moduleKey].components))
      for (const [i, value] of item.pastedValues.entries()) {
        const comKey = item.comKey + i
        if (comKey < components.length) {
          if (item.pricingLevel) {
            components[comKey].moduleColumns[item.component][item.cellKey][item.pricingLevel] = value
          } else {
            components[comKey].moduleColumns[item.component][item.cellKey] = value
          }
        } else {
          const moduleColumns = state.getters.currentProjectModuleColumns,
          newComponent = {
            name: '',
            moduleColumns: {
              fixedElements: [],
              hourlyElements: [],
              metaElements: [],
              percentTasks: []
            },
          };
          for (const key in moduleColumns) {
            for (const [i, val] of moduleColumns[key].entries()) {
              if (key == 'metaElements' && i == 0) {
                newComponent.moduleColumns[key].push(value)
              } else if (key == 'metaElements' && i == 2) {
                newComponent.moduleColumns[key].push({ lo: 0, mid: 1, hi: 0 })
              } else {
                newComponent.moduleColumns[key].push({ lo: 0, mid: 0, hi: 0 })
              }
            }
          }
          components.push(newComponent)
        }
      }
      await state.dispatch('updateProjectFull', {
        projectid: item.projectid,
        child: "/modules/" + item.moduleKey + "/components",
        value: components
      });
      resolve()
    });
  },
  async pasteComponentName(state, item) {
    return new Promise(async (resolve, reject) => {
      let components = JSON.parse(JSON.stringify(state.getters.currentProjectModules[item.moduleKey].components))
      for (const [i, value] of item.pastedValues.entries()) {
        const comKey = item.comKey + i
        if (comKey < components.length) {
          components[comKey].name = value
        } else {
          const moduleColumns = state.getters.currentProjectModuleColumns,
          newComponent = {
            name: value,
            moduleColumns: {
              fixedElements: [],
              hourlyElements: [],
              metaElements: [],
              percentTasks: []
            },
          };
          for (const key in moduleColumns) {
            for (const [i, val] of moduleColumns[key].entries()) {
              if (key == 'metaElements' && i == 0) {
                newComponent.moduleColumns[key].push('')
              } else if (key == 'metaElements' && i == 2) {
                newComponent.moduleColumns[key].push({ lo: 0, mid: 1, hi: 0 })
              } else {
                newComponent.moduleColumns[key].push({ lo: 0, mid: 0, hi: 0 })
              }
            }
          }
          components.push(newComponent)
        }
      }
      await state.dispatch('updateProjectFull', {
        projectid: item.projectid,
        child: "/modules/" + item.moduleKey + "/components",
        value: components
      });
      resolve()
    });
  },
  addNewModule(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/moduleColumns")
      .once("value", snap => {
        var modules = snap.val();
        console.log("got moduleColumns", modules);
        var newModule = {
          name: "New Group",
          components: [
            {
              moduleColumns: {
                fixedElements: [],
                hourlyElements: [],
                metaElements: [],
                percentTasks: []
              },
              name: "Deliverable"
            }
          ]
        };

        for (var item2 in modules.fixedElements) {
          newModule.components[0].moduleColumns.fixedElements.push({
            lo: 0,
            mid: 0,
            hi: 0
          });
        }

        for (var item2 in modules.metaElements) {
          if (item2 == modules.metaElements.length - 1) {
            newModule.components[0].moduleColumns.metaElements.push({
              lo: 1,
              mid: 1,
              hi: 1
            });
          } else {
            newModule.components[0].moduleColumns.metaElements.push("");
          }
        }

        for (var item2 in modules.hourlyElements) {
          newModule.components[0].moduleColumns.hourlyElements.push({
            lo: 0,
            mid: 0,
            hi: 0
          });
        }

        for (var item2 in modules.percentTasks) {
          newModule.components[0].moduleColumns.percentTasks.push({
            lo: 0,
            mid: 0,
            hi: 0
          });
        }
        firebaseInstance
          .database()
          .ref("projectsFull/" + item.projectid + "/modules")
          .once("value", snap2 => {
            console.log("*&*&", snap2.val());
            var modules2 = snap2.val();
            if (!modules2) {
              modules2 = [];
            }
            modules2.push(newModule);
            state.dispatch('updateProjectFull', {
              projectid: item.projectid,
              child:  "/modules",
              value: modules2
            });
          })
          .catch(console.error);
      })
      .catch(console.error);
  },
  duplicateComponent(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules/" + item.moduleindex)
      .once("value", snap => {
        var module = snap.val();
        module.components.splice(
          item.componentid,
          0,
          module.components[item.componentid]
        );
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/modules/" + item.moduleindex,
          value: module
        });
      })
      .catch(console.error);
  },
  clearComponent(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules/" + item.moduleindex)
      .once("value", snap => {
        var module = snap.val();
        for (var hourlyElement in module.components[item.componentid]
          .moduleColumns["hourlyElements"]) {
          module.components[item.componentid].moduleColumns["hourlyElements"][
            hourlyElement
          ]["mid"] = 0;
        }
        for (var percentTask in module.components[item.componentid]
          .moduleColumns["percentTasks"]) {
          module.components[item.componentid].moduleColumns["percentTasks"][
            percentTask
          ]["mid"] = 0;
        }
        module.components[item.componentid].moduleColumns["fixedElements"][0][
          "mid"
        ] = 0;
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/modules/" + item.moduleindex,
          value: module
        });
      })
      .catch(console.error);
  },
  selectPriceRange(state, item) {
    state.commit("CHANGE_PRICE_RANGE", item);
  },
  deleteComponent(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/modules/" + item.moduleindex)
      .once("value", snap => {
        var module = snap.val();
        module.components.splice(item.componentid, 1);
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/modules/" + item.moduleindex,
          value: module
        });
      })
      .catch(console.error);
  },
  duplicateColumn(state, item) {
    console.log("duplicateColumn action", item);
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid)
      .once("value", snap => {
        var modules = snap.val().modules;
        var moduleColumns = snap.val().moduleColumns;
        var phases = [...item.phases];

        moduleColumns[item.section].splice(
          item.index,
          0,
          moduleColumns[item.section][item.index]
        );

        for (var module in modules) {
          for (var component in modules[module].components) {
            modules[module].components[component].moduleColumns[
              item.section
            ].splice(
              item.index,
              0,
              modules[module].components[component].moduleColumns[item.section][
                item.index
              ]
            );
          }
        }

        if (item.section == "hourlyElements") {
          for (var phase in phases) {
            if (phases[phase].list) {
              var list = [...phases[phase].list];

              for (var task in phases[phase].list) {
                if (phases[phase].list[task][0] > item.index) {
                  phases[phase].list[task][0] = phases[phase].list[task][0] + 1;
                }
              }

              phases[phase].list = list;
            }
          }
        } else if (item.section == "percentTasks") {
          for (var phase in phases) {
            if (phases[phase].list2) {
              var list = [...phases[phase].list2];
              for (var task in phases[phase].list2) {
                if (phases[phase].list2[task][0] > item.index) {
                  phases[phase].list2[task][0] =
                    phases[phase].list2[task][0] + 1;
                }
              }
              phases[phase].list2 = list;
            }
          }
        }

        var data = {
          modules,
          moduleColumns,
          phases
        };
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "",
          value: data,
          update: true
        });
      })
      .catch(console.error);
  },
  clearColumn(state, item) {
    const modules = JSON.parse(JSON.stringify(state.getters.currentProjectModules)).map(m => {
      const components = m.components.map(com => {
        com.moduleColumns[item.section][item.index]['mid'] = 0
        return com
      })
      m.components = components
      return m
    })
    state.dispatch('updateProjectFull', {
      projectid: item.projectid,
      child:  "",
      update: true,
      value: { modules }
    });
  },
  deleteColumn(state, item) {
    console.log("deleteColumn action", item);
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid)
      .once("value", snap => {
        var modules = snap.val().modules;
        var moduleColumns = snap.val().moduleColumns;
        var phases = [...item.phases];
        moduleColumns[item.section].splice(item.index, 1);
        for (var module in modules) {
          for (var component in modules[module].components) {
            modules[module].components[component].moduleColumns[
              item.section
            ].splice(item.index, 1);
          }
        }
        if (item.section == "hourlyElements") {
          for (var phase in phases) {
            if (phases[phase].list) {
              var list = [...phases[phase].list];
              for (var task in phases[phase].list) {
                console.log("task1", phases[phase].list[task], item.index);
                //   // phases[phase].list = phases[phase].list.filter(v => v[0] !== item.index)
                if (list[task] && list[task][0] == item.index) {
                  console.log("splice this one");
                  list.splice(task, 1);
                }
              }
              console.log("list", list);
              for (var task in phases[phase].list) {
                console.log("task2", phases[phase].list[task], item.index);
                if (phases[phase].list[task][0] > item.index) {
                  phases[phase].list[task][0] = phases[phase].list[task][0] - 1;
                }
              }
              phases[phase].list = list;
            }
          }
        } else if (item.section == "percentTasks") {
          for (var phase in phases) {
            if (phases[phase].list2) {
              var list = [...phases[phase].list2];
              for (var task in phases[phase].list2) {
                console.log("task1", phases[phase].list2[task], item.index);
                //   // phases[phase].list = phases[phase].list.filter(v => v[0] !== item.index)
                if (list[task] && list[task][0] == item.index) {
                  console.log("splice this one");
                  list.splice(task, 1);
                }
              }
              console.log("list", list);
              for (var task in phases[phase].list2) {
                console.log("task2", phases[phase].list2[task], item.index);
                if (phases[phase].list2[task][0] > item.index) {
                  phases[phase].list2[task][0] =
                    phases[phase].list2[task][0] - 1;
                }
              }
              phases[phase].list2 = list;
            }
          }
        }
        var data = {
          modules,
          moduleColumns,
          phases
        };
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "",
          value: data,
          update: true
        });
      })
      .catch(console.error);
  },

  addNewComponent(state, item) {
    const moduleColumns = state.getters.currentProjectModuleColumns,
      newComponent = {
        name: item.name,
        moduleColumns: {
          fixedElements: [],
          hourlyElements: [],
          metaElements: [],
          percentTasks: []
        },
      };
    for (const key in moduleColumns) {
      for (const [i, val] of moduleColumns[key].entries()) {
        if (key == 'metaElements' && i == 0) {
          newComponent.moduleColumns[key].push('')
        } else if (key == 'metaElements' && i == 2) {
          newComponent.moduleColumns[key].push({ lo: 0, mid: 1, hi: 0 })
        } else {
          newComponent.moduleColumns[key].push({ lo: 0, mid: 0, hi: 0 })
        }
      }
    }
    state.dispatch('updateProjectFull', {
      projectid: item.projectid,
      child:  "/modules/" + item.moduleKey + '/components/' + item.comKey,
      value: newComponent
    });
  },
  changeComponentName(state, item) {
    state.dispatch('updateProjectFull', {
      projectid: item.projectid,
      child:  "/modules/" + item.key3 + "/components/" + item.key2 + "/name",
      value: item.value
    });
  },
  editOverride(state, item) {
    var data = {
      name: item.name,
      type: item.type,
      value: item.value
    };
    state.dispatch('updateProjectFull', {
      projectid: item.projectid,
      child:  "/overrides/" + item.index,
      value: data
    });
  },
  addNewOverride(state, item) {
    var data = [
      ...item.existingOverridesList,
      {
        name: item.name,
        type: item.type,
        value: item.value
      }
    ];
    data.push();
    state.dispatch('updateProjectFull', {
      projectid: item.projectid,
      child:  "/overrides",
      value: data
    });
  },
  deleteCustomOverride(state, item) {
    firebaseInstance
      .database()
      .ref("projectsFull/" + item.projectid + "/overrides")
      .once("value", snap => {
        var overrides = snap.val();
        overrides.splice(item.key, 1);
        state.dispatch('updateProjectFull', {
          projectid: item.projectid,
          child:  "/overrides",
          value: overrides
        });
      })
      .catch(console.error);
  },

  keyUpCell(state) {
    const oldSelectedCell = state.getters.selectedCell
    if (!oldSelectedCell) {
      return;
    }
    const modules = state.getters.currentProjectModules,
      components = modules[oldSelectedCell.moduleKey].components
    let newSelectedCell = {}
    if (oldSelectedCell.comKey === 0) {
      if (oldSelectedCell.moduleKey === 0) {
        newSelectedCell = { ...oldSelectedCell }
      } else {
        newSelectedCell = {
          moduleKey: oldSelectedCell.moduleKey - 1
        }
      }
    } else if (oldSelectedCell.comKey === undefined) {
      newSelectedCell = {
        ...oldSelectedCell,
        comKey: components.length - 1
      }
    } else {
      newSelectedCell = {
        ...oldSelectedCell,
        comKey: oldSelectedCell.comKey - 1
      }
    }
    state.commit("UPDATE_SELETED_CELL", newSelectedCell);
  },
  keyDownCell(state) {
    const oldSelectedCell = state.getters.selectedCell
    if (!oldSelectedCell) {
      return;
    }
    const modules = state.getters.currentProjectModules,
      components = modules[oldSelectedCell.moduleKey].components
    if (oldSelectedCell.comKey === components.length - 1) {
      state.commit("UPDATE_SELETED_CELL", {
        moduleKey: oldSelectedCell.moduleKey
      });
    } else if (oldSelectedCell.comKey === undefined) {
      if (oldSelectedCell.moduleKey !== modules.length - 1) {
        state.commit("UPDATE_SELETED_CELL", {
          moduleKey: oldSelectedCell.moduleKey + 1,
          comKey: 0
        });
      }
    } else {
      state.commit("UPDATE_SELETED_CELL", {
        ...oldSelectedCell,
        comKey: oldSelectedCell.comKey + 1
      });
    }
  },
  keyLeftCell(state) {
    const oldSelectedCell = state.getters.selectedCell
    if (
        !oldSelectedCell ||
        oldSelectedCell.moduleKey === undefined ||
        oldSelectedCell.comKey === undefined
    ) { return; }
    const modules = state.getters.currentProjectModules,
      components = modules[oldSelectedCell.moduleKey].components,
        columns = components[oldSelectedCell.comKey].moduleColumns
    if (
      oldSelectedCell.prefix === undefined &&
      oldSelectedCell.cellKey === undefined
    ) {
      return
    }
    if (
      oldSelectedCell.prefix === 'meta' &&
      oldSelectedCell.cellKey === 0
    ) {
      state.commit("UPDATE_SELETED_CELL", {
        moduleKey: oldSelectedCell.moduleKey,
        comKey: oldSelectedCell.comKey
      });
      return
    }
    if (
      oldSelectedCell.prefix === 'fixed' &&
      oldSelectedCell.cellKey === 0
    ) {
      state.commit("UPDATE_SELETED_CELL", {
        ...oldSelectedCell,
        prefix: 'meta',
        cellKey: columns.metaElements.length - 1,
      });
      return
    }
    if (
      oldSelectedCell.prefix === 'hourly' &&
      oldSelectedCell.cellKey === 0
    ) {
      state.commit("UPDATE_SELETED_CELL", {
        ...oldSelectedCell,
        prefix: 'fixed',
        cellKey: columns.fixedElements.length - 1,
      });
      return
    }
    if (
      oldSelectedCell.prefix === 'percent' &&
      oldSelectedCell.cellKey === 0
    ) {
      state.commit("UPDATE_SELETED_CELL", {
        ...oldSelectedCell,
        prefix: 'hourly',
        cellKey: columns.hourlyElements.length - 1,
      });
      return
    }
    state.commit("UPDATE_SELETED_CELL", {
      ...oldSelectedCell,
      cellKey: oldSelectedCell.cellKey - 1
    });
  },
  keyRightCell(state) {
    const oldSelectedCell = state.getters.selectedCell
    if (
        !oldSelectedCell ||
        oldSelectedCell.moduleKey === undefined ||
        oldSelectedCell.comKey === undefined
    ) { return; }
    const modules = state.getters.currentProjectModules,
      components = modules[oldSelectedCell.moduleKey].components,
      columns = components[oldSelectedCell.comKey].moduleColumns
    if (
      oldSelectedCell.prefix === undefined &&
      oldSelectedCell.cellKey === undefined
    ) {
      state.commit("UPDATE_SELETED_CELL", {
        ...oldSelectedCell,
        prefix: 'meta',
        cellKey: 0,
      });
      return
    }
    if (
      oldSelectedCell.prefix === 'meta' &&
      oldSelectedCell.cellKey === columns.metaElements.length - 1
    ) {
      state.commit("UPDATE_SELETED_CELL", {
        ...oldSelectedCell,
        prefix: 'fixed',
        cellKey: 0,
      });
      return
    }
    if (
      oldSelectedCell.prefix === 'fixed' &&
      oldSelectedCell.cellKey === columns.fixedElements.length - 1
    ) {
      if (columns.hourlyElements && columns.hourlyElements.length) {
        state.commit("UPDATE_SELETED_CELL", {
          ...oldSelectedCell,
          prefix: 'hourly',
          cellKey: 0,
        });
      }
      return
    }
    if (
      oldSelectedCell.prefix === 'hourly' &&
      oldSelectedCell.cellKey === columns.hourlyElements.length - 1
    ) {
      if ( columns.percentTasks && columns.percentTasks.length ) {
        state.commit("UPDATE_SELETED_CELL", {
          ...oldSelectedCell,
          prefix: 'percent',
          cellKey: 0,
        });
      }
      return
    }
    if (
      oldSelectedCell.prefix === 'percent' &&
      oldSelectedCell.cellKey === columns.percentTasks.length - 1
    ) {
      return
    }
    state.commit("UPDATE_SELETED_CELL", {
      ...oldSelectedCell,
      cellKey: oldSelectedCell.cellKey + 1
    });
  },
  ctrlKeyUpCell(state) {
    const oldSelectedCell = state.getters.selectedCell
    if (!oldSelectedCell) {
      return;
    }
    if (oldSelectedCell.moduleKey === 0) {
      state.commit("UPDATE_SELETED_CELL", {
        ...oldSelectedCell,
        comKey: 0
      });
    } else {
      state.commit("UPDATE_SELETED_CELL", {
        ...oldSelectedCell,
        moduleKey: oldSelectedCell.moduleKey - 1,
        comKey: 0
      });
    }
  },
  ctrlKeyDownCell(state) {
    const oldSelectedCell = state.getters.selectedCell
    if (!oldSelectedCell) {
      return;
    }
    const modules = state.getters.currentProjectModules,
      components = modules[oldSelectedCell.moduleKey].components

    if (oldSelectedCell.moduleKey === modules.length - 1) {
      state.commit("UPDATE_SELETED_CELL", {
        ...oldSelectedCell,
        comKey: components.length-1
      });
    } else {
      state.commit("UPDATE_SELETED_CELL", {
        ...oldSelectedCell,
        moduleKey: oldSelectedCell.moduleKey + 1,
        comKey: 0
      });
    }
  },
  ctrlKeyLeftCell(state) {
    const oldSelectedCell = state.getters.selectedCell
    if (
      !oldSelectedCell ||
      oldSelectedCell.moduleKey === undefined ||
      oldSelectedCell.comKey === undefined
    ) { return; }
    const modules = state.getters.currentProjectModules,
      components = modules[oldSelectedCell.moduleKey].components,
      columns = components[oldSelectedCell.comKey].moduleColumns
    if (!oldSelectedCell.prefix) {
      return;
    } else if (
      oldSelectedCell.prefix === 'meta'
    ) {
      state.commit("UPDATE_SELETED_CELL", {
        moduleKey: oldSelectedCell.moduleKey,
        comKey: oldSelectedCell.comKey,
      });
    } else if (oldSelectedCell.prefix === 'fixed') {
      state.commit("UPDATE_SELETED_CELL", {
        moduleKey: oldSelectedCell.moduleKey,
        comKey: oldSelectedCell.comKey,
      });
    } else if (oldSelectedCell.prefix === 'hourly') {
      state.commit("UPDATE_SELETED_CELL", {
        moduleKey: oldSelectedCell.moduleKey,
        comKey: oldSelectedCell.comKey,
      });
    } else if (oldSelectedCell.prefix === 'percent') {
      state.commit("UPDATE_SELETED_CELL", {
        ...oldSelectedCell,
        prefix: 'hourly',
        cellKey: 0
      });
    }
  },
  ctrlKeyRightCell(state) {
    const oldSelectedCell = state.getters.selectedCell
    if (
      !oldSelectedCell ||
      oldSelectedCell.moduleKey === undefined ||
      oldSelectedCell.comKey === undefined
    ) { return; }
    const modules = state.getters.currentProjectModules,
      components = modules[oldSelectedCell.moduleKey].components,
      columns = components[oldSelectedCell.comKey].moduleColumns
    if (
      !oldSelectedCell.prefix || oldSelectedCell.prefix === 'meta'
    ) {
      if (columns.hourlyElements && columns.hourlyElements.length) {
        state.commit("UPDATE_SELETED_CELL", {
          ...oldSelectedCell,
          prefix: 'hourly',
          cellKey: 0,
        });
        return
      }
      if (columns.percentTasks && columns.percentTasks.length) {
        state.commit("UPDATE_SELETED_CELL", {
          ...oldSelectedCell,
          prefix: 'percent',
          cellKey: 0,
        });
        return
      }
      state.commit("UPDATE_SELETED_CELL", {
        ...oldSelectedCell,
        prefix: 'fixed',
        cellKey: 0,
      });
    } else if (oldSelectedCell.prefix === 'fixed') {
      if (columns.hourlyElements && columns.hourlyElements.length) {
        state.commit("UPDATE_SELETED_CELL", {
          ...oldSelectedCell,
          prefix: 'hourly',
          cellKey: 0,
        });
        return
      }
      if (columns.percentTasks && columns.percentTasks.length) {
        state.commit("UPDATE_SELETED_CELL", {
          ...oldSelectedCell,
          prefix: 'percent',
          cellKey: 0,
        });
        return
      }
    } else if (oldSelectedCell.prefix === 'hourly') {
      if (columns.percentTasks && columns.percentTasks.length) {
        state.commit("UPDATE_SELETED_CELL", {
          ...oldSelectedCell,
          prefix: 'percent',
          cellKey: 0,
        });
      } else {
        state.commit("UPDATE_SELETED_CELL", {
          ...oldSelectedCell,
          prefix: 'hourly',
          cellKey: columns.hourlyElements.length - 1,
        });
      }
    } else if (oldSelectedCell.prefix === 'percent') {
      state.commit("UPDATE_SELETED_CELL", {
        ...oldSelectedCell,
        cellKey: columns.percentTasks.length - 1,
      });
    }
  },
  updateSelectedCell(state, item) {
    state.commit("UPDATE_SELETED_CELL", item);
  },
  updateEditingCell(state, item) {
    state.commit("UPDATE_EDITING_CELL", item);
  }
};
